module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-disney-6-40f03357efb4442f1944155593da90cc.webp";